import { ApplicantRequest } from './../../model/applicantRequestModel';
import { ApplicantRequestService } from './../../service/applicant-request.service';
import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import {MatTableDataSource} from '@angular/material/table';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {TokenStorageService} from '../../shared/service/token-storage.service';
import {ApprovalPending} from '../../shared/dto/approval-pending';
import {ApprovalService} from '../../service/approval.service';
import {UserRoleEnum} from '../../shared/enums/user-role.enum';
import {ActivatedRoute, Router} from '@angular/router';
import {ApplicantSearchRequest} from '../../model/applicantSearchRequestModel';

@Component({
  selector: 'app-dash-home',
  templateUrl: './dash-home.component.html',
  styleUrls: ['./dash-home.component.scss']
})

export class DashHomeComponent implements OnInit ,AfterViewInit {
  userName: string;
  userType: string;
  public type: string;
  public applicantSearchRequest: ApplicantSearchRequest = new ApplicantSearchRequest();
  public approvalPendingList: ApprovalPending[];
  approvalPending: ApprovalPending = new ApprovalPending();
  pendingApplicantlist: ApplicantRequest[];
  showPendingRequest: boolean = false;
  showApprovalRequest: boolean = false;
  isLoading2: boolean = false;

  displayedColumns: string[] = [];
  displayedColumnsPendingRequest: string[] =[];
  dataSource: MatTableDataSource<any>;

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;

  constructor(private applicantRequestService: ApplicantRequestService,
              private approvalService: ApprovalService,
              private tokenStorageService: TokenStorageService,
              public route: ActivatedRoute) {
    this.route.paramMap.subscribe(params => {
      this.type = params.get('type');
    });
    this.userName = this.tokenStorageService.getUserObjectToken().username;
    this.userType = this.tokenStorageService.getUserObjectToken().userroleCode;
  }

  applicantFormSearch = new FormGroup({
    applicantRequestId: new FormControl(),
    cdcNo: new FormControl(''),
    passportNo: new FormControl(''),
    nic: new FormControl(''),
    cocNo: new FormControl(''),
    userName: new FormControl(this.tokenStorageService.getUserObjectToken().username),
  });



  ngOnInit() {
    this.getApprovalPendingRequests();

    if(this.type == 'Returned'){
      this.displayedColumns = ['refNo', 'nic', 'name', 'cdc' , 'type' ,'stage', 'createdDate','applicantType', 'action'];
      this.displayedColumnsPendingRequest =['applicantRequestId','fullName', 'cdc' ,'coc','passport','nic','createdTime' ,'applicantType', 'action'];
    }else {
      this.displayedColumns = ['refNo', 'nic', 'name', 'cdc', 'type', 'stage', 'createdDate', 'action'];
      this.displayedColumnsPendingRequest = ['applicantRequestId', 'fullName', 'cdc', 'coc', 'passport', 'nic', 'createdTime', 'action'];
    }
  }

  ngAfterViewInit(): void {
    this.dataSource.sort = this.sort;
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onSearch() {
    if(this.userType === UserRoleEnum.DEO){
      this.applicantSearchRequest.applicantRequestId = this.applicantFormSearch.value.applicantRequestId;
      this.applicantSearchRequest.cdcNo = this.applicantFormSearch.value.cdcNo;
      this.applicantSearchRequest.nic = this.applicantFormSearch.value.nic;
      this.applicantSearchRequest.passportNo = this.applicantFormSearch.value.passportNo;
      this.applicantSearchRequest.cocNo = this.applicantFormSearch.value.cocNo;
      this.applicantSearchRequest.type = this.type;
      this.applicantSearchRequest.userName = this.userName;

      this.applicantRequestService.search(this.applicantSearchRequest).subscribe(
        (result: any ) => {
          this.pendingApplicantlist = result;
          this.dataSource = new MatTableDataSource(this.pendingApplicantlist);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      );

    }else {
      this.approvalPending.appRefNo = this.applicantFormSearch.value.applicantRequestId;
      this.approvalPending.cdcNo = this.applicantFormSearch.value.cdcNo;
      this.approvalPending.name = this.applicantFormSearch.value.name;
      this.approvalPending.nic = this.applicantFormSearch.value.nic;
      this.approvalPending.loginUser = this.userName;

      this.approvalService.searchApprovalPendingData(this.approvalPending).subscribe(
        (result: any ) => {
          this.approvalPendingList = result;
          this.dataSource = new MatTableDataSource(this.approvalPendingList);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      );
    }
  }

  getApprovalPendingRequests() {
    this.isLoading2 = true;
    this.applicantSearchRequest.cdcNo = this.applicantFormSearch.value.cdcNo;
    this.applicantSearchRequest.nic = this.applicantFormSearch.value.nic;
    this.applicantSearchRequest.passportNo = this.applicantFormSearch.value.passportNo;
    this.applicantSearchRequest.cocNo = this.applicantFormSearch.value.cocNo;
    this.applicantSearchRequest.type = this.type;
    this.applicantSearchRequest.userName = this.userName;

    if(this.userType === UserRoleEnum.DEO){
      this.showPendingRequest = true;
      this.applicantRequestService.search(this.applicantSearchRequest).subscribe(
        (result: any ) => {
          this.pendingApplicantlist = result;
          this.isLoading2 = false;
          this.dataSource = new MatTableDataSource(this.pendingApplicantlist);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      );
    }else{
      this.showApprovalRequest = true;
      this.showPendingRequest = false;
      this.approvalPending.appRefNo = null;
      this.approvalPending.cdcNo = null;
      this.approvalPending.name =  null;
      this.approvalPending.nic =  null;
      this.approvalPending.loginUser = this.userName;
      this.approvalPending.type = null;

      this.approvalService.searchApprovalPendingData(this.approvalPending).subscribe(
        (result: any ) => {
          this.approvalPendingList = result;
          this.dataSource = new MatTableDataSource(this.approvalPendingList);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      );
    }
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  setBase64(code: string): string {
    return btoa(code);
  }

  onReset() {
    this.applicantFormSearch.reset({
      applicantRequestId: null,
      cdcNo: null,
      passportNo: null,
      nic: null,
      cocNo: null,
    });
    this.getAllRequestDetails();
  }

  getAllRequestDetails(){
    if(this.userType === UserRoleEnum.DEO){
      this.applicantSearchRequest.applicantRequestId = this.applicantFormSearch.value.applicantRequestId;
      this.applicantSearchRequest.cdcNo = this.applicantFormSearch.value.cdcNo;
      this.applicantSearchRequest.nic = this.applicantFormSearch.value.nic;
      this.applicantSearchRequest.passportNo = this.applicantFormSearch.value.passportNo;
      this.applicantSearchRequest.cocNo = this.applicantFormSearch.value.cocNo;
      this.applicantSearchRequest.type = this.type;
      this.applicantSearchRequest.userName = this.userName;

      this.applicantRequestService.search(this.applicantSearchRequest).subscribe(
        (result: any ) => {
          this.pendingApplicantlist = result;
          this.dataSource = new MatTableDataSource(this.pendingApplicantlist);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      );

    }else {
      this.approvalPending.appRefNo = this.applicantFormSearch.value.applicantRequestId;
      this.approvalPending.cdcNo = this.applicantFormSearch.value.cdcNo;
      this.approvalPending.name = this.applicantFormSearch.value.name;
      this.approvalPending.nic = this.applicantFormSearch.value.nic;
      this.approvalPending.loginUser = this.userName;

      this.approvalService.searchApprovalPendingData(this.approvalPending).subscribe(
        (result: any ) => {
          this.approvalPendingList = result;
          this.dataSource = new MatTableDataSource(this.approvalPendingList);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      );
    }
  }

  protected readonly UserRoleEnum = UserRoleEnum;

  lockRequest(requestId: number){
    this.approvalService.lockRequest(requestId).subscribe(

    )
  }
}
